import i18next from 'i18next';
import {Observable} from 'rxjs';
import {createAction} from 'redux-actions';

import {combineEpics} from 'web-app/util/redux-observable';
import * as actionTypes from 'web-app/react/constants/action-types';
import PostApi from 'web-app/api/post-api';
import {showDialogObservable, DialogChoice} from 'web-app/react/dialog';

const likeImage = action$ =>
    action$.ofType(actionTypes.LIKE_IMAGE).mergeMap(({payload}) =>
        PostApi.likeImage(payload.imageId)
            .map(() => createAction(actionTypes.LIKE_IMAGE_SUCCESS)(payload))
            .catch(e => Observable.of(createAction(actionTypes.LIKE_IMAGE_FAILED)(e.message))),
    );

const unlikeImage = action$ =>
    action$.ofType(actionTypes.UNLIKE_IMAGE).mergeMap(({payload}) =>
        PostApi.unlikeImage(payload.imageId)
            .map(() => createAction(actionTypes.UNLIKE_IMAGE_SUCCESS)(payload))
            .catch(e => Observable.of(createAction(actionTypes.UNLIKE_IMAGE_FAILED)(e.message))),
    );

const tagImage = action$ =>
    action$.ofType(actionTypes.TAG_IMAGE).mergeMap(({payload}) =>
        PostApi.tagImage(payload.imageId, payload.newTag.childId, payload.siteId)
            .map(() => createAction(actionTypes.TAG_IMAGE_SUCCESS)(payload))
            .catch(e => Observable.of(createAction(actionTypes.TAG_IMAGE_FAILED)(e.message))),
    );

const removeImageTag = action$ =>
    action$.ofType(actionTypes.REMOVE_IMAGE_TAG).mergeMap(({payload}) => {
        const confirmObs = payload.showUntagWarning
            ? showDialogObservable({title: '', description: i18next.t('unTagConfirm')})
            : Observable.of(1);

        return confirmObs.mergeMap(selection => {
            if (selection === DialogChoice.OK) {
                return PostApi.removeImageTag(payload.imageId, payload.childId)
                    .map(() => createAction(actionTypes.REMOVE_IMAGE_TAG_SUCCESS)(payload))
                    .catch(e => Observable.of(createAction(actionTypes.REMOVE_IMAGE_TAG_FAILED)(e.message)));
            }
            return Observable.of(createAction(actionTypes.REMOVE_IMAGE_TAG_FAILED)());
        });
    });

export default combineEpics(likeImage, unlikeImage, tagImage, removeImageTag);
